<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="220px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="accessKey" prop="accessKey">
            <el-input v-model.trim="form.accessKey" />
          </el-form-item>
          <el-form-item label="secretKey" prop="secretKey">
            <el-input v-model.trim="form.secretKey" show-password />
          </el-form-item>
          <el-form-item label="bucket" prop="bucket">
            <el-input v-model.trim="form.bucket" />
          </el-form-item>
          <el-form-item label="origin" prop="origin">
            <el-input v-model.trim="form.origin" />
          </el-form-item>
          <el-form-item label="uploadURL" prop="uploadURL">
            <el-input v-model.trim="form.uploadURL" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { setupConfig,getConfig } from '@/api/settings'
import storejs from 'store'
export default {
  name: 'SettingsQiniu',
  data() {
    return {
      labelPosition: 'right',
      form: {
        accessKey:'',
        secretKey: '',
        bucket: '',
        origin: '',
        uploadURL: '',
      },
      rules: {
        // accessKey: [
        //   { required: true, message: '请输入accessKey', trigger: 'blur' },
        // ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const ret = await getConfig({
        key: 'QINIU'
      })
      this.form.accessKey = ret&&ret.basic && ret.basic.accessKey
      this.form.secretKey = ret&&ret.basic && ret.basic.secretKey
      this.form.bucket = ret&&ret.basic && ret.basic.bucket
      this.form.origin = ret&&ret.basic && ret.basic.origin
      this.form.uploadURL = ret&&ret.basic && ret.basic.uploadURL
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({},this.form)
          await setupConfig({
            config: form,
            key: 'QINIU'
          })
          this.getData()
          this.$message.success('保存七牛云配置成功')
        } else {
          this.$message.success('保存七牛云配置失败')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form-item__content {
    .el-rate {
      display: inline-block;
      font-size: 0;
      line-height: 1;
      vertical-align: middle;
    }

    .el-transfer__buttons {
      padding: 10px 10px 0 10px;
    }
  }
}
.title {
  color: #c3c3c3;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 10px;
}
</style>
